import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import AbstractSignupScreen from './AbstractSignupScreen';

export default abstract class AbstractCheckErrorSignupScreen extends AbstractSignupScreen {
  abstract override screenName: UnifiedSignupScreenName;

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public async toNextScreen(): Promise<boolean> {
    return false;
  }

  public override async initWatchers(): Promise<void> {
    super.initWatchers();

    document.querySelectorAll('[hekate-data="email"]').forEach((elm) => {
      const email = `${this.getField(FieldHtmlNameUtil.email).val}`;
      if (!email) {
        elm.textContent = 'email';
        return;
      }
      const bits = email.split('@');
      if (bits.length < 2) {
        elm.textContent = 'email';
        return;
      }

      const domain = bits[1];
      const un = bits[0]?.split('') || [];
      const firstChar = un.shift();
      const lastChar = un.pop();
      const stars = Array(un.length).join('*');
      elm.textContent = `${firstChar}${stars}${lastChar}@${domain}`;
    });
  }

  public getProgress(): number {
    return 0;
  }
}
